import { Component, OnInit }  from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { NgForm }             from '@angular/forms';

import { AzureSsoService } from '../../app-lite/azure-sso/azure-sso.service';
import { LoginService }    from './login.service';
import { MessagesService } from '../../app-lite/messages/messages.service';
import { UserModel }       from '../../app-lite/users/models/user';

@Component({
  selector   : 'wor-login',
  template: require('./login.component.html')
})
export class LoginComponent implements OnInit {
  @BlockUI('loginBlock') block : NgBlockUI;

  user : UserModel = {
    password: '',
    username: ''
  };

  constructor (
    private azureSsoService : AzureSsoService,
    private loginService    : LoginService,
    private messagesService : MessagesService
  ) {}

  login ( form : NgForm ) : void {
    this.messagesService.clearErrors();

    this.block.start();

    this.loginService.login(this.user)
    .catch(error => this.messagesService.error(error))
    .finally(() => this.block.stop());
  }

  loginWithAzure () : void {
    this.block.start();

    this.azureSsoService.getLoginUrl()
    .then(url => window.location.assign(url))
    .catch(error => this.messagesService.error(error))
    .finally(() => this.block.stop());
  }

  ngOnInit () : void {
    let queryString = window.location.search;

    if ( !queryString ) {
      const hash = window.location.hash;

      queryString = hash.includes('?')
        ? hash.substring(hash.indexOf('?'))
        : '';
    }

    if ( queryString.indexOf('session_state') >= 0 ) {
      this.block.start();

      this.loginService.loginWithXero(queryString)
      .catch(error => this.messagesService.error(error))
      .finally(() => this.block.stop());
    }
  }
}
